// import Home from "../views/Home.vue";
// import AboutUs from "../../aboutUs/views/AboutUs.vue";
// import FAQ from "../../FAQ/views/Faq.vue";
// import ContactUs from "../../contactUs/views/ContactUs.vue";
// import UserDashboard from "../../userdashboard/views/Dashboard.vue";


const JobsHome = () => import('../components/JobsHome.vue');

const JobsList = () => import('../components/JobsList.vue');

const JobsDetails = () => import('../components/JobDetails.vue');

const BlogsHome = () => import('../components/BlogsHome.vue');

const BlogList = () => import('../components/BlogList.vue');

const BlogDetails = () => import('../components/BlogDetails.vue');


export default [{
        path: "/jobs",
        component: JobsHome,
        children:[
            {
                path: '',
                component: JobsList,
                name:"JobsList"
            },
            {
                path: ':id',
                component: JobsDetails,
                name:"Job"
            },
        ]
    },

    {
        path: "/blogs",
        component: BlogsHome,
        children:[
            {
                path: '',
                component: BlogList,
                name:"BlogList"
            },
            {
                path: ':id',
                component: BlogDetails,
                name:"Blog"
            },
        ]
    },
    
];